import * as _ from 'lodash';
import { FormApi } from 'final-form';

export default class ZipCodeUtil {
    static getCityState(
        ownerType: string,
        zipCode: string,
        form: FormApi,
        getCityStateProp: (zipCode: number, ownerType?: string, form?: FormApi) => void
    ) {
        const values = form.getState().values;
        let stateId = '';
        let cityValue = '';

        console.log('this is the value of the ownerType');

        if (ownerType === 'ownerJointTenant') {
            stateId = _.get(values, `${ownerType}.state.id`);
            cityValue = _.get(values, `${ownerType}.city`);
        } else {
            stateId = _.get(values, `${ownerType}.address.state.id`);
            cityValue = _.get(values, `${ownerType}.address.city`);
        }

        if (zipCode.length === 5 && !stateId && !cityValue) {
            getCityStateProp(parseInt(zipCode, 10), ownerType, form);
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/ZipCodeUtil.ts